<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box" @click="isSearching = false">
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						쪽지 보내기
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
						<button class="btn-sm round">
							<img src="images/w-setting.png" width="18" alt="" style="margin-top: -2px;"> 관리
						</button>
					</div>
				</div>
				<div class="modal-body p-10 clearfix">
					<div class="send-box left">
						<h3 class="send-tit"><span>받는사람</span></h3>
						<ul class="item-list" :key="hash(sendList)">
							<li v-for="(mberItem, index) in sendList" :key="`sendList-${hash(mberItem)}-${index}`">
								<span class="name" v-if="mberItem.recvName">{{mberItem.recvName}}</span> <span class="info">{{mberItem.mberId}}</span>
								<a class="minus" @click="removeSendList(index)"></a>
							</li>
						</ul>
					</div>
					<div class="send-box right">
						<div class="full-width">
							<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
						</div>
						<div class="btn-group-box m-t-15 pull-right clearfix">
							<div class="btn-group pull-left clearfix">
								<button class="btn bg-deepblue text-white round" @click="sendNote">보내기</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios';server
import server from '../statics/server';

export default {
	name: "ModalNote",
	components: {
	},
	mounted: function () {
		axios.post(server.addr()+server.api.AUTHORIZATION).then( response => {
			this.mberName = response.data.return.mberName;
			this.mberId = response.data.return.mberId;
		});
		let that = this;
		window.tinymce.init({
			selector: '.editorContent',
			height: 500,
			branding: false,
			plugins: [
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table paste imagetools wordcount lineheight"
				],
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image ",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
			images_upload_handler: function(blobInfo, success) {
				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());
				axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
					success("/download/" + response.data);
				});
			},
			setup: function(editor) {
				editor.on('init', function() {
					editor.setContent(that.content);
				});
				editor.on("change", function() {
					that.content = editor.getContent();
				})
			}
		}).then((r) => {this.editorContent = r[0]});
	},
	default: function() {
		return {
			name: this.name,
			show: false,
			sendList: [],
		}
	},
	data: function() {
		return {
			content: "",

			searchedMember: [],
			sendList: JSON.parse(JSON.stringify(this.config.sendList)).map(e=>{
				return {recvName:e.mberName?e.mberName:e.name,mberId:e.mberId?e.mberId:''}
			}),

			mberName: "",
			mberId: "",
			editorContent: null
		}
	},
	props: {
		config: Object
	},
	methods: {
		// 선택한 회원 삭제
		removeSendList: function(index) {
			this.sendList.splice(index, 1);
		},
		sendNote: async function() {
			const { content } = this;
			axios.put(`${server.addr()}${server.api.NOTIFICATION}`, this.sendList.map(e=>{return {
				mberId: e.mberId,
				sendMberId: this.mberId,
				content
			}})).then(() => {
				this.$emit("onDone", "쪽지가 전송되었습니다.");
				this.content = "";
				this.config.show = false;
			})
		},
	}
}
</script>

<style scoped>
._date-time-picker {
	display: inline-block;
	width: 250px;
}
.feature_search_id.on {
	z-index: 1 !important;
	display: block !important;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>